import React, { useState, useEffect } from 'react';

const getTheme = () => {
  try {
    const stored = localStorage.getItem('theme');
    if (stored) return stored;
  } catch (e) {
    // ignore
  }

  // Detect OS/Browser preference
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
    return 'light';
  }
  return 'dark';
};

const setThemeSafe = (theme) => {
  try {
    localStorage.setItem('theme', theme);
  } catch (e) {
    // ignore
  }
};

const ThemeToggle = () => {
  const [theme, setTheme] = useState(getTheme());

  useEffect(() => {
    const applyTheme = (currentTheme) => {
      if (currentTheme === 'dark') {
        document.documentElement.removeAttribute('data-theme'); // default is dark
      } else {
        document.documentElement.setAttribute('data-theme', 'light');
      }
    };

    applyTheme(theme);
  }, [theme]);

  // Listen for system theme changes
  useEffect(() => {
    if (!window.matchMedia) return;
    const mediaQuery = window.matchMedia('(prefers-color-scheme: light)');
    
    const handleChange = (e) => {
      // Only auto-switch if user hasn't manually overridden it in localStorage
      const stored = localStorage.getItem('theme');
      if (!stored) {
        setTheme(e.matches ? 'light' : 'dark');
      }
    };

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
    } else if (mediaQuery.addListener) { // Safari < 14
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange);
      } else if (mediaQuery.removeListener) {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    setThemeSafe(newTheme);
  };

  const getIcon = () => {
    if (theme === 'light') return 'fa-moon-o'; // If it's light, show moon (to switch to dark)
    return 'fa-sun-o'; // If it's dark, show sun (to switch to light)
  };

  return (
    <button 
      onClick={toggleTheme}
      aria-label="Zwischen hellem und dunklem Modus wechseln"
      style={{
        background: 'transparent',
        border: 'none',
        color: 'var(--text-color)',
        fontSize: '18px',
        padding: '10px',
        cursor: 'pointer',
        marginRight: '15px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      title={`Theme: ${theme}`}
    >
      <i className={`fa ${getIcon()}`} aria-hidden="true"></i>
    </button>
  );
};

export default ThemeToggle;
